import { render, staticRenderFns } from "./how-it-works-item.vue?vue&type=template&id=e7d8d6e8&"
import script from "./how-it-works-item.vue?vue&type=script&lang=js&"
export * from "./how-it-works-item.vue?vue&type=script&lang=js&"
import style0 from "./how-it-works-item.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports